import styled from 'styled-components';
import { useRouter } from 'next/router';
import React from 'react';
import Image from 'next/image';

import { useRecoilValue } from 'recoil';
import TitleMask from '@/components/Common/Layout/TitleMask';
import TableTemplate from '@/components/Common/Table/TableTemplate';
import TableRow from '@/components/Common/Table/TableRow';
import TableCount from '@/components/Common/Table/TableCount';
import TablePagination from '@/components/Common/Table/TablePagination';

import { FooterButtonLayout } from '@/components/Common/Table/Table.styled';

import Button, {
  ButtonRadius,
  ButtonSize,
  ButtonVariant,
} from '@/components/Common/Button';
import TextOverFlow from '@/components/Common/TextOverFlow';
import LockIcon from '@/assets/icons/ico-lock.svg';

import usePagination from '@/hooks/usePagination';
import useInquiries from '@/hooks/cs/useInquiries';
import useSearchPost from '@/hooks/admin/useSearchPost';

import { userInfoState } from '@/stores/auth';
import { InquiryT } from '@/api/inquiries';

const CsCreateLayout = styled.div`
  table thead tr th:nth-of-type(2) {
    text-align: left;
  }

  table tbody tr td:nth-of-type(2) {
    display: flex;
    text-align: left;
    color: #343a40;

    .private {
      padding-left: 5px;
    }
  }
`;

const TopWrap = styled.div`
  margin: 48px 0;
  padding: 34px 32px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.whiteGray};
`;
const Answered = styled.span`
  color: ${({ theme }) => theme.palette.lightGray};
`;
const NotAnswered = styled(Answered)`
  color: ${({ theme }) => theme.palette.primary};
`;

function Inquiry() {
  const router = useRouter();
  const pathname = 'inquiries';
  const { queryOptions, setQueryOptions, handleSearch } = useSearchPost({
    pathname,
  });
  const query = router.isReady ? router.query : {};
  const { data } = useInquiries(Number(query?.page) || 1);
  const {
    data: inquiries,
    to,
    total,
    current_page,
    per_page,
  } = usePagination(data?.inquiries);

  const userInfo = useRecoilValue(userInfoState);

  const onClickRow = (data: InquiryT) => {
    const isAuthor = userInfo?.id === data?.user_id;

    if (!isAuthor) {
      window.alert('본인이 작성한 문의내용만 확인 가능합니다.');
      return;
    }
    router.push(`/cs/inquiries/${data.id}`);
  };

  const tableList = inquiries.map((i: InquiryT) => (
    <tr
      key={i.id}
      style={{
        cursor: 'pointer',
      }}
      onClick={() => onClickRow(i)}
    >
      <td>{i.id}</td>
      <td>
        {i.title}
        {/* <Image src={IcoNew} width={16} alt="new" /> */}
        <span className="private">
          <Image src={LockIcon} alt="d" width="12px" height="16px" />
        </span>
      </td>
      <td>
        <TextOverFlow width={100} title={i.name}>
          {i.name}
        </TextOverFlow>
      </td>
      <td>{new Date(i.created_at).toLocaleString()}</td>
      <td>
        {i.reply && <NotAnswered>답변완료</NotAnswered>}
        {!i.reply && <Answered>답변대기</Answered>}
      </td>
    </tr>
  ));

  return (
    <TitleMask title="1:1 문의하기">
      {/* TODO: 추후 작업
      <TopWrap>
        <DateSearch
          options={QNA_OPTIONS}
          startDate={queryOptions.date1}
          endDate={queryOptions.date2}
          queryOptions={queryOptions}
          placeholder="검색어를 입력해주세요"
          handleSubmit={handleSearch}
          setOptions={setQueryOptions}
        />
      </TopWrap>
      */}
      <CsCreateLayout>
        <TableTemplate
          colgroup={COLGROUP}
          Column={<TableRow columns={QNA_COLUMNS} />}
          Body={tableList}
          Footer={
            <>
              <FooterButtonLayout>
                <TableCount totalCount={total} presentCount={to} />
                <Button
                  type="button"
                  width={250}
                  height={56}
                  size={ButtonSize.Big}
                  radius={ButtonRadius.Oval}
                  variant={ButtonVariant.Default}
                  label="문의하기"
                  onClick={() => {
                    router.push(`/cs/inquiries/create`);
                  }}
                />
              </FooterButtonLayout>
              <TablePagination
                page={current_page}
                perPage={per_page}
                count={total}
                query={query}
                redirectPath={`/cs/${pathname}`}
              />
            </>
          }
        />
      </CsCreateLayout>
    </TitleMask>
  );
}

export default Inquiry;

const QNA_COLUMNS = ['No.', '제목', '작성자', '날짜', '답변여부'];

const QNA_OPTIONS = [
  { value: 'title1', text: '제목' },
  { value: 'title2', text: '제목' },
  { value: 'title3', text: '제목' },
];

const COLGROUP = [
  { id: 1, col: '5%' },
  { id: 2, col: '25%' },
  { id: 3, col: '5%' },
  { id: 4, col: '10%' },
  { id: 5, col: '5%' },
];
